import columns from '../../../react-table/helpers/columns';

export default (data) => {
  const {
    FilteredTextColumn,
    FilteredDateColumn,
    FilteredNumberColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredDateColumn('Date (UTC)', 'date'),
        new FilteredTextColumn('Outbound operator', 'outboundOperator'),
        new FilteredTextColumn('Outbound IMPC', 'outboundImpc'),
        new FilteredTextColumn('Inbound operator', 'inboundOperator'),
        new FilteredTextColumn('Inbound IMPC', 'inboundImpc'),
        new FilteredNumberColumn('Base movement count', 'baseMovementCount'),
        new FilteredNumberColumn('LID movement count', 'lidMovementCount'),
        new FilteredTextColumn('Trip', 'trip'),
      ],
    },
  ];
};
